import { Controller } from "@hotwired/stimulus"
import { api, apiErrorMessage } from "../composables/useApi"

export default class extends Controller {
  static values = { handle: String, friendshipId: Number }
  static targets = ["button", "status"]

  sendRequest() {
    this.buttonTarget.disabled = true
    this.statusTarget.textContent = ""

    api.post("/friendships", { handle: this.handleValue })
      .then(() => {
        this.element.innerHTML = `
          <span class="btn btn-secondary btn-sm" disabled>
            <i class="fas fa-clock"></i> Request Sent
          </span>
        `
      })
      .catch(error => {
        this.buttonTarget.disabled = false
        this.statusTarget.textContent = apiErrorMessage(error, "Could not send request")
      })
  }

  acceptRequest() {
    this.buttonTarget.disabled = true
    this.statusTarget.textContent = ""

    api.patch(`/friendships/${this.friendshipIdValue}/accept`, { circle: "friends" })
      .then(() => {
        this.element.innerHTML = `
          <span class="friendship-badge">
            <i class="fas fa-user-check"></i> Friends
          </span>
        `
      })
      .catch(error => {
        this.buttonTarget.disabled = false
        this.statusTarget.textContent = apiErrorMessage(error, "Could not accept request")
      })
  }
}
